import BranchTitleCard from './branchTitleCard.container';

export default BranchTitleCard;